import React from 'react';
import { CmsContentProvider, useCmsContent } from '../content/CmsContentContext';
import './admin.css';

const EditorFrame = ({ children }) => {
  const { cancel, save, saving } = useCmsContent();

  return (
    <div className="cms-editor-shell">
      <div className="cms-editor-bar">
        <button type="button" onClick={cancel}>Cancel</button>
        <button type="button" disabled={saving} onClick={save}>Save</button>
      </div>
      {children}
    </div>
  );
};

const AdminEditor = ({ children }) => (
  <CmsContentProvider mode="editor">
    <EditorFrame>{children}</EditorFrame>
  </CmsContentProvider>
);

export default AdminEditor;
